<script setup lang="ts">
import CreationFilter from '@/components/Menus/Filters/CreationFilter.vue';
import { type MessageSchema } from '@/i18n';
import { useDishesStore } from '@/stores/dishesStore';
import Textarea from 'primevue/textarea';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const dishesStore = ref(useDishesStore());
</script>

<template>
  <CreationFilter>
    <template #title>{{ t('creationFilters.additionalInstructions') }}</template>
    <template #content>
      <Textarea
        v-model="dishesStore.generationParams.supp_prompt"
        class="w-full"
        rows="4"
        :placeholder="t('creationFilters.additionalInstructionsPlaceholder')"
      />
    </template>
  </CreationFilter>
</template>
